<script setup lang="ts">
const themeStore = useThemeStore();
const changeTheme = (): void =>
{
    themeStore.changeTheme();
};
</script>

<template>
    <button type="button" class="navbar-toggler" @click="changeTheme">
        <i class="far fa-fw fa-circle-half-stroke" />
    </button>
</template>
